import CustomTagReader from './CustomTagReader'

export default CustomTagReader